import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import axios from 'axios';
import { translations } from '../i18n/translations';

const LanguageContext = createContext(null);
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const LANGUAGES = [
  { code: 'fr', label: 'Français', short: 'FR' },
  { code: 'en', label: 'English', short: 'EN' },
  { code: 'es', label: 'Español', short: 'ES' },
  { code: 'de', label: 'Deutsch', short: 'DE' },
  { code: 'zh', label: '中文', short: '中文' },
];

// Keys that can be overridden from the admin "Textes du site" panel
export const EDITABLE_KEYS = [
  { key: 'hero.title', label: 'Accroche principale (hero)' },
  { key: 'hero.quote', label: 'Citation (hero)' },
  { key: 'hero.subtitle', label: 'Sous-titre services (hero)' },
  { key: 'intro.title', label: "Titre — L'agence" },
  { key: 'intro.text', label: "Texte — L'agence" },
  { key: 'sections.title', label: 'Titre — Univers' },
  { key: 'featured.title', label: 'Titre — Biens à la une' },
  { key: 'values.title', label: 'Titre — Notre approche' },
  { key: 'cta.title', label: 'Titre — Appel à contact' },
  { key: 'cta.text', label: 'Texte — Appel à contact' },
  { key: 'about.lead', label: 'Slogan — À propos' },
  { key: 'about.mission', label: 'Mission — À propos' },
];

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem('starkke_lang') || 'fr');
  const [overrides, setOverrides] = useState({});

  useEffect(() => {
    axios
      .get(`${API}/site-content`, { timeout: 12000 })
      .then((res) => setOverrides(res.data?.overrides || {}))
      .catch(() => {});
  }, []);

  const changeLang = useCallback((l) => {
    setLang(l);
    localStorage.setItem('starkke_lang', l);
  }, []);

  const toggleLang = useCallback(() => {
    setLang((prev) => {
      const next = prev === 'fr' ? 'en' : 'fr';
      localStorage.setItem('starkke_lang', next);
      return next;
    });
  }, []);

  // translation helper: t('nav.home') — checks admin overrides first
  const t = useCallback(
    (path) => {
      const ov = overrides[path]?.[lang];
      if (ov && ov.trim()) return ov;
      const parts = path.split('.');
      let node = translations[lang];
      for (const p of parts) {
        node = node?.[p];
        if (node === undefined) return path;
      }
      return node;
    },
    [lang, overrides]
  );

  return (
    <LanguageContext.Provider value={{ lang, changeLang, toggleLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLang must be used within LanguageProvider');
  return ctx;
};
